<nav class="hr-list-tabs" role="tablist" aria-label="HR workspace sections">
  @for (tab of tabs; track tab.key) {
    <button
      type="button"
      role="tab"
      class="hr-list-tab"
      [class.active]="activeTab === tab.key"
      [attr.aria-selected]="activeTab === tab.key"
      [attr.tabindex]="activeTab === tab.key ? 0 : -1"
      (click)="selectTab(tab.key)"
    >
      <i [class]="tab.icon"></i>
      <span>{{ tab.label }}</span>
      @if (tab.badge !== undefined) {
        <span class="tab-badge">{{ tab.badge }}</span>
      }
    </button>
  }
</nav>
